import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import TravelAgentBasicInfo from './TravelAgentBasicInfo';
import TravelAgentOperationsInfo from './TravelAgentOperationsInfo';
import TravelAgentAssignment from './TravelAgentAssignment';
import TravelAgentFinance from './TravelAgentFinance';
import TravelAgentAddOnInfo from './TravelAgentAddOnInfo';
import { SaveConfirmModel } from '../../../customControl/SaveConfirmModel';
import { getAllData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../../components/commonClass/Session';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { agencyType, bankMaster, communicationChannel, domainWiseDisable, isSavedTabForm, kamManager, leadSource, optionListTA, paymentTerms, regionAssignment, salesManager, tabCollectionTravelCorporate, TravelAgentAssignmentRef, travelSegment, warningValidationTab } from './TravelAgent.interface';
import { getuserprofileimagebyid } from '../../../components/commonClass/CommonFunctions';
import { AgentStatus } from '../../../_constants/agent.constant';
interface CreateTravelAgentProps {
    statusId?: number;
    isOnBording?: number;
    setAgentStatusId?: any;
}

function CreateTravelAgent({ statusId, isOnBording: propIsOnBording, setAgentStatusId: parentSetAgentStatusId }: CreateTravelAgentProps) {

    const dispatch = useDispatch();
    const location = useLocation();
    const locationsData = useSelector((store: any) => store.locationsdata.data);
    const [warningMessages, setWarningMessages] = useState<warningValidationTab[]>([])
    const [loginUserDomainMasterId, setLoginUserDomainMasterId] = useState(0); // 1 - Internal, 2 - TA (Travel Agent), 3 - Corporate 
    const [isOnBording, setIsOnBording] = useState(0);

    useEffect(() => {
        if (propIsOnBording !== undefined) {
            setIsOnBording(propIsOnBording);
        }
    }, [propIsOnBording]);

    const travelAgentAssignmentRef = useRef<TravelAgentAssignmentRef>(null);

    const defaultTab: tabCollectionTravelCorporate = {
        id: 1,
        idName: "pills-Basic-Info-tab",
        name: "Basic Info",
        dataBsTarget: "#pills-Basic-Info",
        ariaControls: "pills-Basic-Info",
        ariaSelected: true,
        isSavedName: "BasicInfo",
    };

    const [selectedTab, setSelectedTab] = useState<tabCollectionTravelCorporate>(defaultTab);
    const [redirectTab, setRedirectTab] = useState<tabCollectionTravelCorporate>(defaultTab);
    const [isRedirect, setIsRedirect] = useState<boolean>(false);
    const [isConfirm, setIsConfirm] = useState<number>(0);
    const [isSaved, setIsSaved] = useState<isSavedTabForm>({
        BasicInfo: false,
        OperationsInfo: false,
        Assignment: false,
        Finance: false,
        AddOnInfo: false,
    });
    const [modalShow, setModalShow] = useState<boolean>(false);
    const [TravelAgentId, setTravelAgentId] = useState(0);
    const [agentStatusId, setAgentStatusId] = useState<number | undefined>(statusId || location?.state?.statusId);
    const [travelAgentOptionList, setTravelAgentOptionList] = useState<optionListTA>();

    const tabs: tabCollectionTravelCorporate[] = [
        {
            id: 1,
            idName: "pills-Basic-Info-tab",
            name: "Basic Info",
            dataBsTarget: "#pills-Basic-Info",
            ariaControls: "pills-Basic-Info",
            ariaSelected: true,
            isSavedName: "BasicInfo",
        },
        {
            id: 2,
            idName: "pills-Operations-Info-tab",
            name: "Operations Info",
            dataBsTarget: "#pills-Operations-Info",
            ariaControls: "pills-Operations-Info",
            ariaSelected: false,
            isSavedName: "OperationsInfo",
        },
        {
            id: 3,
            idName: "pills-Assignment-tab",
            name: "Assignment",
            dataBsTarget: "#pills-Assignment",
            ariaControls: "pills-Assignment",
            ariaSelected: false,
            isSavedName: "Assignment",
        },
        {
            id: 4,
            idName: "pills-Finance-tab",
            name: "Finance",
            dataBsTarget: "#pills-Finance",
            ariaControls: "pills-Finance",
            ariaSelected: false,
            isSavedName: "Finance",
        },
        {
            id: 5,
            idName: "pills-Add-on-info-tab",
            name: "Add-on Info",
            dataBsTarget: "#pills-Add-on-info",
            ariaControls: "pills-Add-on-info",
            ariaSelected: false,
            isSavedName: "AddOnInfo",
        },
    ];

    const handleTabChange = (ele: tabCollectionTravelCorporate) => {
        if (ele?.id !== selectedTab?.id) {
            setRedirectTab(ele);
            if (selectedTab.isSavedName && isSaved[selectedTab.isSavedName]) {
                setSelectedTab(ele);
                setModalShow(false);
            }
            else {
                setModalShow(true);
            }
        }
    }

    useEffect(() => {
        if (isConfirm === 2) {
            setModalShow(false);
            setIsConfirm(0);
        }
    }, [isConfirm])

    useEffect(() => {
        if (isRedirect && redirectTab) {
            setSelectedTab(redirectTab);
            setIsRedirect(false);
        }
    }, [isRedirect, redirectTab])

    const gettravelagentoptions = async () => {
        const travelagentoptions = await getAllData('/midoffice/v1/gettravelagentoptions');
        if (travelagentoptions?.status) {
            travelagentoptions?.data?.agencyTypeOption?.filter((fil: agencyType) => fil.IsActive)?.map((obj: agencyType) => {
                obj.label = obj?.AgencyType
                obj.value = obj?.AgencyTypeId
                return obj;
            })

            travelagentoptions.data.agencyTypeOption = [5, 1, 2, 3, 4]?.reduce((acc: any, curr: any) => {
                const data: any = travelagentoptions?.data?.agencyTypeOption?.find((obj: any) => obj.AgencyTypeId === curr)
                data && acc.push(data);
                return acc;
            }, []);

            travelagentoptions?.data?.communicationChannelOption?.filter((fil: communicationChannel) => fil.IsActive)?.map((obj: communicationChannel) => {
                obj.label = obj?.CommunicationChannelName
                obj.value = obj?.CommunicationChannelId
                return obj;
            })
            travelagentoptions?.data?.travelSegmentOption?.filter((fil: travelSegment) => fil.IsActive)?.map((obj: travelSegment) => {
                obj.label = obj?.TravelSegmentName
                obj.value = obj?.TravelSegmentId
                return obj;
            })
            travelagentoptions?.data?.paymentTerms?.filter((fil: paymentTerms) => fil.IsActive)?.map((obj: paymentTerms) => {
                obj.label = obj?.PaymentTerms
                obj.value = obj?.TravelAgentPaymentTermsMasterId
                return obj;
            })
            travelagentoptions?.data?.regionList?.map((obj: regionAssignment) => {
                obj.label = obj?.regionName
                obj.value = obj?.regionId
                obj.kamUsers = obj?.kamUsers?.map((ele: kamManager) => {
                    ele.label = ele?.userName
                    ele.value = ele?.userMasterID
                    return ele;
                })
                obj.salesManagerUsers = obj?.salesManagerUsers?.map((ele: salesManager) => {
                    ele.label = ele?.userName
                    ele.value = ele?.userMasterID
                    return ele;
                })
                return obj;
            })
            travelagentoptions?.data?.bankMasterList?.map((obj: bankMaster) => {
                obj.label = obj?.BankName
                obj.value = obj?.BankMasterId
                return obj;
            })
            travelagentoptions?.data?.leadSourceList?.map((obj: leadSource) => {
                obj.label = obj?.LeadSource
                obj.value = obj?.LeadSourceMasterId
                return obj;
            })

            setTravelAgentOptionList(travelagentoptions?.data);
        }
    }

    const getLoginUserDomianId = async () => {
        const userById = await getuserprofileimagebyid();
        if (userById?.status) {
            setLoginUserDomainMasterId(userById?.data?.[0]?.DomainMasterId)
        }
    }

    useEffect(() => {
        async function fetchData() {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const IsOnBoarding = location?.state?.itemData?.IsOnBoarding || 0;
                setIsOnBording(IsOnBoarding);
                Promise.allSettled([
                    getLoginUserDomianId(),
                    gettravelagentoptions()
                ])
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();
    }, [])

    const isTabDisable = TravelAgentId > 0 ? TravelAgentId : location?.state?.Id ?? 0; // manage tabs disabled

    //#region manage fields enable/disable depends on Domain or On board
    const domainWiseDisable: domainWiseDisable = useMemo(() => {
        const effectiveStatusId = agentStatusId;
        const isUneditableStatus = ([AgentStatus.Submit, AgentStatus.Approved] as number[]).includes(Number(effectiveStatusId));

        return {
            assignmentField: !(loginUserDomainMasterId === 1 && isOnBording === 1),
            isExternalUser: loginUserDomainMasterId !== 1 && (isOnBording === 1 ? isUneditableStatus : true),
            loginUserDomainMasterId: loginUserDomainMasterId,
            isOnBording: isOnBording
        }
    }, [loginUserDomainMasterId, isOnBording, agentStatusId])
    //#endregion

    useEffect(() => {
        if (agentStatusId !== undefined && parentSetAgentStatusId) {
            parentSetAgentStatusId(agentStatusId);
        }
    }, [agentStatusId, parentSetAgentStatusId])


    return (
        <Fragment>
            <div className="m-2 heading_color">
                <h4>{selectedTab?.name}</h4>
            </div>
            <div className="m-2">
                <div className='container tab_section px-0'>
                    <ul className="nav nav-pills nav-justified mb-3 pt-3 col-12 " id="pills-tab" role="tablist">
                        {
                            tabs?.map((element) => {
                                return (
                                    <li
                                        key={element?.id}
                                        className="nav-item mt-1 mx-1"
                                        role="presentation"
                                        onClick={() => handleTabChange(element)}
                                    >
                                        <button className={`nav-link ${element?.id === selectedTab?.id && "active"}`}
                                            id={element?.idName}
                                            // data-bs-toggle="pill"
                                            // data-bs-target={element?.dataBsTarget}
                                            type="button" role="tab"
                                            aria-controls={element?.ariaControls}
                                            aria-selected={element?.ariaSelected}
                                            disabled={isTabDisable <= 0}
                                        >
                                            <div className="d-flex justify-content-center align-items-center ">
                                                <div className='fw-500'> {element?.name} </div>
                                                {
                                                    warningMessages?.map((obj: any) => {
                                                        return obj?.tabId === element?.id && <i className="mx-2 fa-solid fa-triangle-exclamation"></i>
                                                    })
                                                }
                                            </div>
                                        </button>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">

                    <div className={`tab-pane fade show ${selectedTab?.id === 1 && "active"}`} id="pills-Basic-Info" role="tabpanel" aria-labelledby="pills-Basic-Info-tab">
                        {
                            selectedTab?.id === 1 &&
                            <TravelAgentBasicInfo
                                tabId={1}
                                selectedTabId={selectedTab?.id}
                                setIsSaved={setIsSaved}
                                isConfirm={isConfirm}
                                setIsConfirm={setIsConfirm}
                                setIsRedirect={setIsRedirect}
                                setTravelAgentId={setTravelAgentId}
                                TravelAgentId={TravelAgentId}
                                travelAgentOptionList={travelAgentOptionList}
                                locationsData={locationsData}
                                setWarningMessages={setWarningMessages}
                                domainWiseDisable={domainWiseDisable}
                                setAgentStatusId={setAgentStatusId}
                                datalist={location?.state?.datalist}
                            />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 2 && "active"}`} id="pills-Operations-Info" role="tabpanel" aria-labelledby="pills-Operations-Info-tab">
                        {
                            selectedTab?.id === 2 &&
                            <TravelAgentOperationsInfo
                                tabId={2}
                                selectedTabId={selectedTab?.id}
                                setIsSaved={setIsSaved}
                                isConfirm={isConfirm}
                                setIsConfirm={setIsConfirm}
                                setIsRedirect={setIsRedirect}
                                TravelAgentId={TravelAgentId}
                                travelAgentOptionList={travelAgentOptionList}
                                setWarningMessages={setWarningMessages}
                                domainWiseDisable={domainWiseDisable}
                            />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 3 && "active"}`} id="pills-Assignment" role="tabpanel" aria-labelledby="pills-Assignment-tab">
                        {
                            selectedTab?.id === 3 &&
                            <TravelAgentAssignment
                                ref={travelAgentAssignmentRef}
                                tabId={3}
                                selectedTabId={selectedTab?.id}
                                isSaved={isSaved}
                                setIsSaved={setIsSaved}
                                isConfirm={isConfirm}
                                setIsConfirm={setIsConfirm}
                                setIsRedirect={setIsRedirect}
                                TravelAgentId={TravelAgentId}
                                travelAgentOptionList={travelAgentOptionList}
                                locationsData={locationsData}
                                warningMessages={warningMessages}
                                setWarningMessages={setWarningMessages}
                                domainWiseDisable={domainWiseDisable}
                            />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 4 && "active"}`} id="pills-Finance" role="tabpanel" aria-labelledby="pills-Finance-tab">
                        {
                            selectedTab?.id === 4 &&
                            <TravelAgentFinance
                                tabId={4}
                                selectedTabId={selectedTab?.id}
                                setIsSaved={setIsSaved}
                                isConfirm={isConfirm}
                                setIsConfirm={setIsConfirm}
                                setIsRedirect={setIsRedirect}
                                TravelAgentId={TravelAgentId}
                                travelAgentOptionList={travelAgentOptionList}
                                setWarningMessages={setWarningMessages}
                                domainWiseDisable={domainWiseDisable}
                            />
                        }
                    </div>
                    <div className={`tab-pane fade show ${selectedTab?.id === 5 && "active"}`} id="pills-Add-on-info" role="tabpanel" aria-labelledby="pills-Add-on-info-tab">
                        {
                            selectedTab?.id === 5 &&
                                <TravelAgentAddOnInfo
                                    tabId={5}
                                    selectedTabId={selectedTab?.id}
                                    setIsSaved={setIsSaved}
                                    isConfirm={isConfirm}
                                    setIsConfirm={setIsConfirm}
                                    setIsRedirect={setIsRedirect}
                                    TravelAgentId={TravelAgentId}
                                    travelAgentOptionList={travelAgentOptionList}
                                    warnings={{ Assignment: travelAgentAssignmentRef?.current }}
                                    setWarningMessages={setWarningMessages}
                                    domainWiseDisable={domainWiseDisable}
                                    statusId={agentStatusId}
                                />
                        }
                    </div>
                </div>
            </div>
            <SaveConfirmModel
                show={modalShow}
                onHide={() => setModalShow(false)}
                yesconfirm={() => setIsConfirm(1)}
                noconfirm={() => { setModalShow(false); setSelectedTab(redirectTab); }}
                modletitle="Confirmation"
                message="There are unsaved data, do want to save first ?"
            />
        </Fragment >
    )
}

export default CreateTravelAgent